import React from 'react';
import { Box, Typography, Container, Button, useMediaQuery } from '@mui/material';
import { Fade, Zoom } from '@mui/material';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import hourglass from '../../../assets/Gifs/hourglass.gif';
const Overlay = () => {
  const isSm = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  return (
    <Fade in timeout={500}>
      <Box
        sx={{
          height: '40%',
          position: 'absolute',
          top: '20vh',
          left: 15,
          right: 15,
          borderRadius: '15px',
          backgroundColor: 'rgba(255, 255, 255, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          color: 'grey',
        }}
      >
        <Container
          sx={{
            textAlign: 'center',
            animation: 'fadeIn 2s ease-in-out',
            '@keyframes fadeIn': {
              '0%': { opacity: 0 },
              '100%': { opacity: 1 },
            },
          }}
        >
          <Zoom in timeout={1000}>
            <img
              src={hourglass}
              style={{
                height: isSm ? '80px' : '100px',
                width: isSm ? '80px' : '100px',
                backdropFilter: 'grayscale(100%)',
              }}
            />
          </Zoom>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
            Coming Soon
          </Typography>
          <Typography variant="body1" sx={{ mb: 4 }} textAlign={'center'}>
            We are working hard to bring this feature to you. Stay tuned!
          </Typography>
        </Container>
      </Box>
    </Fade>
  );
};

export default Overlay;
